var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-table', [_c('thead', [_c('tr', _vm._l(_vm.tableData.headers, function (header) {
    return _c('th', {
      key: header.label
    }, [_vm._v(_vm._s(header.label))]);
  }), 0)]), _c('tbody', _vm._l(_vm.tableData.rows, function (row, idx) {
    return _c('tr', {
      key: idx
    }, _vm._l(row.values, function (value, vIdx) {
      return _c('td', {
        key: value.value
      }, [_vm.tableData.headers[vIdx] && _vm.tableData.headers[vIdx].columnType === _vm.KeyboardingTableColumnType.TALLY_MARK ? _c('tally-marks', {
        attrs: {
          "value": value.value
        }
      }) : _c('div', [_vm._v(_vm._s(value.value))])], 1);
    }), 0);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }